import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { HowTo } from "../types/howTo";
import { getClassName } from "@pairtreefamily/utils";
import { getImageURL } from "../utils/getImageURL";
import { reduceRichText } from "../utils/reduceRichText";
import { formatDurationFromSeconds } from "../utils/formatDurationFromSeconds";
import Card from "./card";
import Clock from "./icons/clock";
import { LinkTo } from "./linkTo";
import { RichText } from "./richText";
import { Heading4, Heading5, Inline, Paragraph } from "./text";

export type HowToCardProps = HowTo;

export function HowToCard(props: HowToCardProps) {
  const article = props;
  const image = article.primaryImage;

  const imageClass = getClassName("rounded-md", "float-left");

  const className = getClassName(
    "flex",
    "flex-col",
    "gap-2",
    "bg-darkblue",
    "h-full",
    "rounded-[15px]",
    "p-8",
    "justify-between",
  );
  return (
    <LinkTo.HowTos slug={article.slug?.current} className="h-[415px]">
      <Card hoverable className={className}>
        <div>
          {image && (
            <img
              className={imageClass}
              src={getImageURL(image).width(400).height(200).url()}
              alt={image.alt}
            />
          )}
          <p className="text-overline-1 flex">
            {article?.audienceData &&
              article.audienceData.map((data) => {
                return data.icon ? (
                  <img
                    alt={data.icon.alt}
                    key={data.icon.asset._ref}
                    className="w-[40px] [&:not(:first-of-type)]:ml-[-10px]"
                    src={getImageURL(data.icon).url()}
                  />
                ) : null;
              })}
            <div className="text-overline-2 my-auto ml-4 text-white">
              {article.audienceData &&
                article.audienceData.map((data, index) => {
                  return (
                    <span key={`${data.displayName}${index}`}>
                      {data.displayName}
                      {index < article.audienceData.length - 1 ? " & " : ""}
                    </span>
                  );
                })}
            </div>
          </p>
        </div>
        <div>
          <h3 className="text-head-6 line-clamp-5 text-white">
            {article.title}
          </h3>
          {article.readTime && (
            <p className="my-2 flex">
              <Clock className={"my-auto mr-2 inline text-white"} />
              <span className="text-body-4 my-auto text-white">
                {formatDurationFromSeconds(article.readTime, true)} read
              </span>
            </p>
          )}
          {article.lede && (
            <p className="line-clamp-3 text-white">
              {reduceRichText(article.lede)}
            </p>
          )}
        </div>
      </Card>
    </LinkTo.HowTos>
  );
}

export default HowToCard;
